$( window ).load(function() {
    if($(".header-content-information").length){
        $(".toggle").click(function(){
            let attribute = $(this).attr("data-toggle");
            
            $(".toggle").removeClass("active")
            $(this).addClass("active")
    
            $(".body-content").removeClass("active");
            $(".body-content.content-"+attribute).addClass("active");
        })
    }

    if($(".input-group-qty").length){
        var minus = document.querySelector(".btn-subtract")
        var add = document.querySelector(".btn-add");
        var quantity = document.querySelector(".product-form__input--quantity");

        // includes button minus disablement if at minimum or below
        const minimum = 1;

        minus.addEventListener("click", function(){
            if (quantity.value <= minimum) {
                minus.disabled = true;
                return; // return to avoid decrementing
            } else {
                minus.disabled = false;
            }
            quantity.value--;
        });

        add.addEventListener("click", function() {
            if (quantity.value > minimum) {
                minus.disabled = false;
            }
            quantity.value++;
        });

    }
});